var Button = require('pagemodules/_btn');
var Title = require('pagemodules/_ttl');
var Tabs = require('pagemodules/_tabs');
var MenuBtn = require('pagemodules/_menuBtn');
var Fa = require('pagemodules/_fa');
var GNav = require('pagemodules/_gNav');
var LNav = require('pagemodules/_lNav');
var SwitchImg = require('pagemodules/_switchImg');
var Top = require('pagemodules/_top');
var Participate = require('pagemodules/_participate');
var PastParticipateList = require('pagemodules/_pastParticipateList.js');
var News = require('pagemodules/_news');
var About = require('pagemodules/_about');
var Turbidity = require('pagemodules/_turbidity');
var Accordion = require('pagemodules/_accordion');
var Water = require('pagemodules/_water');
var Report = require('pagemodules/_report');
var RoadToWater = require('pagemodules/_roadToWater');

var Pages = {

  init:function () {
    GNav.init();
    LNav.init();
    Top.init();
    Button.init();
    MenuBtn.init();
    SwitchImg.init();
    Tabs.init();
    Accordion.init();
    Participate.init();
    PastParticipateList.init();
    Fa.init();
    News.init();
    About.init();
    Title.init();
    Turbidity.init();
    Report.init();
    Water.init();
    RoadToWater.init();
  }
};



module.exports = Pages;



//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/__init__.js
// module id = 1
// module chunks = 0